export const EMPTY_CALENDAR_FILTERS = Object.freeze({
  completedOnly: false,
  pmaIds: [],
  memberIds: [],
});

export const FILTER_SECTIONS = Object.freeze({
  PMAS: 'pmas',
  MEMBERS: 'members',
});

export const getFilterOptionLabel = (option) => {
  if (!option) return '';
  const fullName = `${option.name ?? ''} ${option.last_name ?? ''}`.trim();
  return fullName || option.email || String(option.id ?? '');
};

export const getSelectedFilterCount = (filters) =>
  Number(Boolean(filters.completedOnly)) + filters.pmaIds.length + filters.memberIds.length;

export const hasActiveCalendarFilters = ({
  advancedFilters,
  categories,
  categoryChecks,
  onlyWithHacs,
  showSystemTasks,
}) =>
  Boolean(onlyWithHacs) ||
  !showSystemTasks ||
  getSelectedFilterCount(advancedFilters) > 0 ||
  categories.some((category) => categoryChecks?.[category.id] === false);

export const toggleSelectedId = (selectedIds, id) =>
  selectedIds.includes(id)
    ? selectedIds.filter((selectedId) => selectedId !== id)
    : [...selectedIds, id];
